var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConditions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "conditions_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".conditions_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "conditions_svg__st0",
    d: "M88.7 67.1h24.7v19.6h19.7v26.7h-19.7v19.7H86.7v-19.7H67.1V86.7h21.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-icon-primary)",
    d: "M92.7 127.1v-19.7H73.1V92.7h21.6V73.1h12.7v19.6h19.7v14.7h-19.7v19.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "conditions_svg__XMLID_7_",
    className: "conditions_svg__st0",
    d: "M82.7 61.1V21.7c0-3.7-3-6.8-6.8-6.8H21.7c-3.7 0-6.8 3-6.8 6.8v99.6c0 2.9 2.4 5.3 5.3 5.3h57.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "conditions_svg__st0",
    d: "M64 14.9v7c0 2.4-1.9 4.3-4.3 4.3H40.5c-2.4 0-4.3-1.9-4.3-4.3v-7"
  })));
}
export default SvgConditions;